import {
  Component,
  ViewChild,
  HostListener,
  Output,
  EventEmitter
} from "@angular/core";
import { NavComponent } from "../../core/component/Nav.Component";
import { ErrorObject } from "../../core/entities/ErrorObject";
import { ModalComponent } from "ng2-bs3-modal";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { GenEnum } from "../../shell/shared/general.enum";
import { errorArgs } from "./error.config";
import { ToastsManager } from "ng2-toastr";
import { AppConstants } from "../../app.constant";
import { errorDisplayMode } from "../config";

@Component({
  moduleId: module.id,
  selector: "ixs-error",
  templateUrl: "error.component.html",
  styleUrls: ["error.component.scss"]
})
export class ErrorComponent {
  private toaster: ToastsManager;
  ErrorArray: any = [];
  title: any;
  type: number;
  private innerValue: number = 0;
  Id: string;
  toolbarEvent: any;
  get value() {
    return this.innerValue;
  }

  @ViewChild("errorModal") errorModal: ModalComponent;

  @Output()
  confirm: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.toaster = AppConstants.injector.get(ToastsManager);
  }

  async ngOnInit() {
    this.errorModal.backdrop = false;
    this.errorModal.keyboard = true;
  }

  public showErrors(
    messages: string | ErrorObject[],
    title?: string,
    type?: number,
    displaymode: number = errorDisplayMode.Modal
  ) {

    let msg;
    let pushList = {};
    var mode = errorDisplayMode.Modal;
    if (messages) {
      if (type) {

        this.type = type;
      } else {

        this.type = GenEnum.ErrorTypes.Error;
      }
      if (displaymode && displaymode === mode) {


        if (title === undefined) {
          title =
            this.type === GenEnum.ErrorTypes.Warning
              ? "Warning"
              : this.type === GenEnum.ErrorTypes.Info
                ? "Information"
                : this.type === GenEnum.ErrorTypes.Success
                  ? "Success"
                  : "Error";
        }
        this.title = title;
        if (typeof messages === "string") {
          msg = messages;
          this.ErrorArray = [
            {
              dec: msg
            }
          ];
        } else {
          var count = 1;
          messages.forEach(element => {
            pushList = {
              dec: count + "." + " " + element.Description
            };
            this.ErrorArray.push(pushList);
            count++;
          });
        }
        this.errorModal.open("md");
        // this.toaster.success(msg, title, { enableHTML: true });
        // setTimeout(() => {
        //   this.drag();
        // }, 0);
        // $('#modalLRForm').modal({ backdrop: 'static', keyboard: true })
        // $("#modalLRForm").modal('show');
      }
      else {

        if (typeof messages === "string") {
          msg = messages;
        } else {
          msg = "";
          messages.forEach(error => {
            msg += error;
            msg += "<br/>";
          });
        }
        if (type === GenEnum.ErrorTypes.Error) {
          this.toaster.error(msg, title, { enableHTML: true });
          this.innerClose(1);
        }
        else if (type === GenEnum.ErrorTypes.Success) {
          this.toaster.success(msg, title, { enableHTML: true });
          this.innerClose(1);
        }
        else if (type === GenEnum.ErrorTypes.Info) {
          this.toaster.info(msg, title, { enableHTML: true });
          this.innerClose(1);
        }
        else if (type === GenEnum.ErrorTypes.Warning) {
          this.toaster.warning(msg, title, { enableHTML: true });

        }
      }
    }

  }

  async innerClose(value: number) {
    this.innerValue = value;
    this.ErrorArray = [];
    this.errorModal.close();

    // $("#modalLRForm").modal('hide');
    this.confirm.emit(<errorArgs>{
      Id: this.Id,
      value: this.innerValue,
      type: this.type
    });
  }

  @HostListener("document:keyup", ["$event"]) handleKeyUp(event) {
    if (event.keyCode === 27) {
      this.innerClose(0);
    }
    else if (event.keyCode === 13) {
      this.innerClose(1);
    }
  }

  // async drag() {

  //   $(".modal-dialog").draggable({
  //     handle: ".modal-header"
  //   });

  //   var modal = $("#errorModal");
  //   var body = $(window);
  //   var dialog = modal[0].children[0];
  //   $(".modal-dialog").css({ top: 0, left: 0, right: 0, bottom: 0 });
  //   var h = modal[0].children[0].clientHeight;

  //   var bh = body.height();
  //   dialog['style'].top = ((bh - h) / 2) - 50 + "px";

  // }
}



// WEBPACK FOOTER //
// ./src/app/components/error/error.component.ts